export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20angle%20shot%20of%20curated%20fashion%20product%20flat%20lay%20with%20sneakers%20jackets%20bags%20and%20accessories%20arranged%20artistically%20on%20warm%20concrete%20floor%2C%20overhead%20editorial%20fashion%20photography%2C%20diffused%20studio%20lighting%20creating%20soft%20shadows%2C%20warm%20terracotta%20and%20sand%20tones%2C%20clean%20modern%20aesthetic&width=1600&height=900&seq=hero-main-v2&orientation=landscape"
          alt="OOPBuy Spreadsheet Fashion Collection"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-24 pb-16">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" />
            <span className="text-sm text-background-50 font-medium">Täglich aktualisiert &middot; 2026</span>
          </div>

          {/* H1 */}
          <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-6">
            OOPBuy Spreadsheet
            <br />
            <span className="text-primary-400">Deutschland</span>
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-background-100 max-w-2xl mx-auto mb-8 leading-relaxed">
            Der größte deutschsprachige Fashion Shopping Guide für OOPBuy.
            Über <strong className="text-background-50">3.000 geprüfte Produkte</strong> aus den Bereichen
            Sneaker, Streetwear, Accessoires und mehr. Dein ultimativer Guide zum smarten Shoppen aus China.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center gap-2"
            >
              OOPBuy Spreadsheet
              <span className="w-5 h-5 rounded-full bg-background-50/20 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full text-sm font-semibold bg-background-50 text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
            <div className="text-center">
              <div className="font-heading font-bold text-2xl md:text-3xl text-background-50">3.000+</div>
              <div className="text-xs md:text-sm text-background-200 mt-1">Produkte</div>
            </div>
            <div className="w-px h-10 bg-white/20 hidden md:block" />
            <div className="text-center">
              <div className="font-heading font-bold text-2xl md:text-3xl text-background-50">Täglich</div>
              <div className="text-xs md:text-sm text-background-200 mt-1">Aktualisiert</div>
            </div>
            <div className="w-px h-10 bg-white/20 hidden md:block" />
            <div className="text-center">
              <div className="font-heading font-bold text-2xl md:text-3xl text-background-50">200k+</div>
              <div className="text-xs md:text-sm text-background-200 mt-1">Shoppers</div>
            </div>
          </div>
        </div>
      </div>

      {/* Trust badges */}
      <div className="absolute bottom-0 left-0 right-0 z-10 bg-background-50/95 backdrop-blur-sm border-t border-background-200/50">
        <div className="w-full px-4 md:px-6 lg:px-10 py-3">
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 text-xs text-foreground-600">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-accent-500"></i>
              Verifizierte Verkäufer
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-camera-line text-accent-500"></i>
              QC Fotos verfügbar
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line text-accent-500"></i>
              Tägliche Updates
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-global-line text-accent-500"></i>
              Weltweiter Versand
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}